import * as React from 'react'

import { SafeHtml } from '@thg-commerce/gravity-elements'
import { styled, Text, spacing } from '@thg-commerce/enterprise-theme'

export interface QuoteProps {
  text: string
  cite?: string
  link?: string
}

const StyledQuote = styled.blockquote`
  ${Text('bodyText', 'default')};
  position: relative;
  quotes: '“' '”' '‘' '’';

  &::before {
    content: open-quote;
    left: 0;
    top: 0;
    margin-top: -${spacing(3)};
    position: absolute;
  }

  &::after {
    content: close-quote;
    right: 0;
    position: absolute;
  }

  &::before,
  &::after {
    ${Text('xlarge1', 'alternate')};
    color: ${(props) => props.theme.colors.palette.accent.base};
  }

  * {
    ${Text('bodyText', 'default')};
  }
`

const Citation = styled.a<{ link?: string }>`
  text-decoration: ${(props) => (props.link ? 'underline' : 'none')};
  text-align: right;
  display: block;

  &::before {
    content: '– ';
  }
`

export const Quote = React.memo(({ cite, link, text }: QuoteProps) => {
  return (
    <React.Fragment>
      {text && (
        <StyledQuote className="quote">
          <div
            style={{
              textAlign: !cite ? 'center' : 'inherit',
              margin: `${spacing(1)} ${spacing(4)}`,
            }}
          >
            <SafeHtml content={text} />
            {cite && (
              <Citation link={link} href={link ? link : ''} target="_blank">
                {cite}
              </Citation>
            )}
          </div>
        </StyledQuote>
      )}
    </React.Fragment>
  )
})
